(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-weekday-alert"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-cm-weekday-alert]';
    let timer;

    function updateCountdowns() {
      let active = false;
      const now = Date.now();

      document.querySelectorAll(selector).forEach(alert => {
        const expiry = Number(alert.dataset.expiresAt);
        const countdown = alert.querySelector('[data-cm-weekday-countdown]');
        const remaining = Math.ceil((expiry - now) / 1000);

        if (!Number.isFinite(expiry) || remaining <= 0 || !countdown) {
          alert.hidden = true;
          return;
        }

        const days = Math.floor(remaining / 86400);
        const hours = Math.floor(remaining % 86400 / 3600);
        const minutes = Math.floor(remaining % 3600 / 60);
        const seconds = remaining % 60;
        const pad = value => String(value).padStart(2, '0');

        countdown.textContent = `${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
        alert.hidden = false;
        active = true;
      });

      return active;
    }

    function refreshCountdowns() {
      window.clearTimeout(timer);
      if (updateCountdowns() && !document.hidden) {
        timer = window.setTimeout(refreshCountdowns, 1000);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshCountdowns, { once: true });
    } else {
      refreshCountdowns();
    }

    document.addEventListener('shopify:section:load', refreshCountdowns);
    document.addEventListener('visibilitychange', refreshCountdowns);
    window.addEventListener('pageshow', refreshCountdowns);
  })();
  } catch(e) { console.error(e); }
})();

})();
